import { NgFor } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ActivityApi } from 'app/modules/dashboard/api/activity.api';
import { UserApi } from 'app/modules/dashboard/api/user.api';
import { emit } from 'process';

// eslint-disable-next-line no-restricted-imports
import { TrainingLogSharePlatformItemComponent } from './tl-share-platform-item/tl-share-platform-item.component';

export interface SharingProvider {
  icon: string; // icon of the sharing provider (eg. https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Facebook_F_icon.svg/2048px-Facebook_F_icon.svg.png)
  link: string | undefined; // link to share
  name: string; // name of the sharing provider (eg. facebook)
  apiName: string; // name of the sharing provider in the API (eg. facebook, twitter, etc.)
}

@Component({
  imports: [TranslateModule, NgFor, TrainingLogSharePlatformItemComponent],
  selector: 'app-ts-share-activity',
  standalone: true,
  styleUrls: [
    './ts-share-activity.component.scss',
    '../ts-modal.component.scss',
  ],
  template: `
    <body>
      <div class="header">
        <h2 translate>Partager</h2>
      </div>
      <div class="content">
        <div id="sharing-list">
          <tl-share-platform-item
            *ngFor="let item of userProviders"
            [platform]="item"
            [activityId]="activityId"
            [sessionId]="sessionId"></tl-share-platform-item>
        </div>
      </div>

      <div class="footer"></div>
    </body>
  `,
})
export class TrainingLogShareModalComponent implements OnInit {
  @Input() activityId: number;
  @Input() sessionId: number;

  sharingItems: SharingProvider[] = [
    {
      icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Facebook_F_icon.svg/2048px-Facebook_F_icon.svg.png',
      link: undefined,
      name: 'facebook',
      apiName: 'facebook',
    },

    {
      icon: 'https://www.svgrepo.com/show/315543/adidas.svg',
      link: undefined,
      name: 'addidas Running',
      apiName: 'adidas_running',
    },

    {
      icon: 'https://wpassets.trainingpeaks.com/wp-content/uploads/2025/03/25102652/TPApp_Icon.jpg',
      link: undefined,
      name: 'Training Peaks',
      apiName: 'trainingpeaks',
    },

    {
      icon: 'https://images.icon-icons.com/2699/PNG/512/strava_logo_icon_170697.png',
      link: undefined,
      name: 'Strava',
      apiName: 'strava',
    },

    {
      icon: 'https://cdn.iconscout.com/icon/free/png-256/free-runkeeper-3629031-3030388.png',
      link: undefined,
      name: 'runkeeper',
      apiName: 'runkeeper',
    },

    {
      icon: 'https://asset.brandfetch.io/idZnU4VOzn/idfzccNE29.jpeg',
      link: undefined,
      name: 'decathlon',
      apiName: 'decathlon',
    },

    {
      icon: 'https://log.concept2.com/build/images/homepage/icon_log.png',
      link: undefined,
      name: 'logbook concept2',
      apiName: 'logbookConcept2',
    },

    {
      icon: 'https://media.licdn.com/dms/image/D560BAQEGR8wQnIG9Fw/company-logo_200_200/0/1698332586284/noliosport_logo?e=2147483647&v=beta&t=fz9efJYVSNAoSlyeqwt4-2kV0LUdYzT7Zlif8T8oHRM',
      link: undefined,
      name: 'nolio',
      apiName: 'nolio',
    },

    {
      icon: 'https://cdn.iconscout.com/icon/free/png-256/free-email-2026367-1713640.png?f=webp',
      link: undefined,
      name: 'email',
      apiName: 'email',
    },
  ];

  userPlatforms: string[] = [];
  userProviders: SharingProvider[] = [];

  constructor(private userApi: UserApi) {}

  ngOnInit(): void {
    this.userApi.getSharablePlatform().subscribe((platforms: string[]) => {
      const userPlatforms = platforms;
      this.userProviders = this.sharingItems.filter((item: SharingProvider) =>
        userPlatforms.includes(item.apiName)
      );
    });
  }
}
